import { releaseName } from 'app/config/constants'
import { when } from 'mobx'
import { store } from 'store/store'
import { Meta, Options } from 'type/Options'
import { postMessageSelf } from 'util/message'
import { omitNil } from 'util/object'

function getParams(): Record<string, string | undefined> {
  return Object.fromEntries(new URLSearchParams(location.search))
}

function getMeta(): Meta {
  return {
    location: location.href,
    self: true,
    selfie: true,
  }
}

function getOptions(): Options {
  const { product, user } = getParams()
  return omitNil({
    external: true,
    product,
    user,
  })
}

async function go(screen: 'selfie' | 'fullbody') {
  console.info('try on', releaseName)
  const options = getOptions()
  const meta = getMeta()

  postMessageSelf('setup', { options, meta })
  await when(() => store.setupDone)

  store.state = 'max'
  store.screen = screen
}

// Со стенда по QR приходят на /selfie или /fullbody — тип фото задаёт сама страница.
export function selfie() {
  const { pathname } = location
  if (pathname === '/selfie') void go('selfie')
  if (pathname === '/fullbody') void go('fullbody')
}
